import { Component, OnInit, Output, Input, EventEmitter, ViewChild } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { CallCenterInboundCallComponent } from './../../call-center/call-center-inbound-call/call-center-inbound-call.component';
@Component({
  selector: 'app-base',
  templateUrl: './base.component.html',
  styleUrls: ['./base.component.scss'],

})
export class BaseComponent implements OnInit {
  @ViewChild(CallCenterInboundCallComponent, { static: false }) child: CallCenterInboundCallComponent;

  constructor(//private socket: Socket,
  ) {
    // this.socket.connect();
    // this.socket.on('connect', () => {
    //   if (localStorage.getItem('username')) {
    //     this.socket.emit('userJoin', { userId: localStorage.getItem("username"), isAvailable: true }, (err) => {
    //       if (err) {
    //         alert(err)
    //       }
    //     })
    //   }

    // })
  }

  ngOnInit() {

    //if call center guy login this method sent request socket to register for incoming calls
    // this.socket.emit('agentJoin', { agentId: localStorage.getItem("username") }, (error) => {
    //   if (error) {
    //     alert(error.error)
    //   }
    // })

    // this.socket.emit('userJoin', { userId: localStorage.getItem("username"), isAvailable: true }, (err) => {
    //   if (err) {
    //     alert(err)
    //   }
    // })
    
  }

  ngAfterViewInit() {
    //this method listens for inbounds calls then popup shown
    // this.socket.on('receiveCall', (data) => {
    //   console.log(data);
    //   console.log("call recieved by rrs");
    //   if (localStorage.getItem("username") == data.agentId) {
    //     localStorage.setItem("CurrentInBoundCallDetails", JSON.stringify(data));
    //     this.child.showDialog("INBOUND");
    //   }
    // })
  }

  isOpen: boolean;
  navOpen($event): void {
    this.isOpen = !this.isOpen;
  }


 
}
